import React, { useState, useEffect } from "react";
import { IonButton, IonCol, IonGrid, IonImg, IonItem, IonLabel, IonRadio, IonRadioGroup, IonRow, IonText } from "@ionic/react";
import "./execution.scss";
import { TripLoadStop } from "./TripLoadStop";
import { TripDetailsWeb } from "./TripDetails";
import { completeTripApiRequest } from "../../../actions/carrierAssign/action";
import { StartTripModel } from "../../../models/home/StartTrip.model";
import {
  COMPLETE_TRIP_CTA_TEXT,
  NO,
  non_managed_equipment_load_question,
  NO_NETWORK,
  PCmiler,
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  YES,
  PageView,
  ALERT_BUTTON_ROLES
} from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { CompleteTripModel } from "../../../models/home/CompleteTrip.model";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../actions/App/action";
import { LoadMapSatellite } from "../../../components/app/LoadMap/LoadMapSatellite";
import ToggleButton from "../toggle-button/ToggleButton";
import { LoadMap } from "../../../components/app/LoadMap/LoadMap";
import { checkDriverUnassignStatus } from "../../../components/app/ShipmentUpdateScreen/ShipmentUpdate.Util";
import { Alert } from "../../../components/Alert/Alert";
import i18n from "../../../../i18n";
import { IONICWrapper } from "../../../utils/common";
import { LoadPCmilerMapsSatellite } from "../../../components/app/LoadMap/LoadPCmilerMapsSatellite";

export const Execution: React.FunctionComponent<any> = (props: any) => {
  const dispatch = useDispatch();
  const { loadDetails = {}, userDetails = {} } = props;
  let loadStops: any[] = (loadDetails && loadDetails.loadStop) || [];
  loadStops =
    loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  const startTripModel = new StartTripModel();
  const currentOpenStop: number = startTripModel.getCurrentOpenStop(
    loadDetails
  );

  const onCompleteTrip = () => {
    if (!props.isNetworkAvailable) {
      dispatch(
        showAlert({
          isShowAlert: true,
          alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
          alertTitle: NO_NETWORK,
        })
      );
      return;
    }
    const objModel: CompleteTripModel = new CompleteTripModel();
    dispatch(
      completeTripApiRequest(
        objModel.completeTrip({
          carrierId: userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          shipmentId: loadDetails.shipmentId,
          sourceSystem: loadDetails.sourceTMS,
          userId: userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
        }),
        loadDetails.shipmentId
      )
    );
    setScreenName("screen_shipment_update");
    // Analytics implementation
    logEvent(EVENT.UE_COMPLETE_TRIP, {
      screen: SCREEN.SHIPMENT_DETAILS,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      shipmentId: loadDetails.shipmentId,
    });
  };
  const [showMap, onShowMap] = useState<boolean>(false);
  const [locationName, onSetLocationName] = useState<string>("");
  const [position, onSetPostion] = useState<any>({});
  const [pageView, onChangePageView] = useState<PageView>(PageView.LIST);
  const [isGPSTrackingOn, setGPSTrackingStatue] = useState<boolean>(false);
  const [showUnassignedMessage, updateShowUnassignedMessage] = useState<boolean>(false);
  const [usePCmilerMaps, setPCmilerMaps] = useState<boolean>(false);
  const [optionSelected, setOptionSelected] = useState<string>('');
  const [optionSelectedErrorMsg, setoptionSelectedErrorMsg] = useState<boolean>(false);

  const driverUnassigned = checkDriverUnassignStatus(
    loadDetails,
    props.userDetails
  );
  useEffect(() => {
    if (driverUnassigned) {
      updateShowUnassignedMessage(driverUnassigned);
    }

    // ContentStack option to use PCmiler Maps or Google Maps
    const _usePCmilerMaps = IONICWrapper.details.keys
      && IONICWrapper.details.keys.configuration.usePCmilerMaps
      || PCmiler.usePCmilerMaps;
    const isPCmilerMaps = _usePCmilerMaps === "true" ? true : false;
    setPCmilerMaps(isPCmilerMaps);

  }, [loadDetails]);

  let question = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.non_managed_equipment_load_question || i18n.t("non_managed_equipment_load_question") || non_managed_equipment_load_question;
  const isManagedEquipment = props.shipmentToStartTrip && props.shipmentToStartTrip.managedEquipment || false;

  return (
    <React.Fragment>
      <Alert
        isOpen={showUnassignedMessage}
        message={i18n.t("unassignedDriverUpdate")}
        backdropDismiss={false}
        mode="ios"
        cssClass="unAssign-alert-web"
        buttons={[
          {
            text: i18n.t("Ok_TEXT"),
            role: ALERT_BUTTON_ROLES.ok,
            handler: () => {
              updateShowUnassignedMessage(false);
              props.removeDriverUnassignedLoad(loadDetails.shipmentId);
              props.history.push("/app/MyLoad/DriverAssigned");
            },
          },
        ]}
      />
      {usePCmilerMaps ? (
        <LoadPCmilerMapsSatellite
          locationName={locationName}
          position={position}
          showSatelliteMap={showMap}
          shipmentId={loadDetails.shipmentId}
          onDismissSatelliteMap={() => {
            onShowMap(false);
          }}
        />
      ) : (
          <LoadMapSatellite
            locationName={locationName}
            position={position}
            showSatelliteMap={showMap}
            shipmentId={loadDetails.shipmentId}
            onDismissSatelliteMap={() => {
              onShowMap(false);
            }}
          />
        )}
      <IonGrid className="execution-trip">
        <IonRow>
          <IonCol size="4" className="view-style">
            <ToggleButton
              handleChange={(value: PageView) => {
                onChangePageView(value);
              }}
              isMapActive={true}
            />
          </IonCol>

          <IonRow >
            {!isManagedEquipment && (
              <IonRow className="non-managed-equip-question">
                <IonText className="question-style">
                  {question}
                </IonText>
                <IonCol>
                  <IonRadioGroup
                    className="radio-group"
                    onIonChange={event => {
                      setOptionSelected(event.detail.value)
                      setoptionSelectedErrorMsg(false)
                    }}
                  >
                    <IonItem>
                      <IonRadio className="radiobutton" value="yes" />
                      <IonLabel className="question-style">{YES}</IonLabel>
                    </IonItem>
                    <IonItem>
                      <IonRadio className="radiobutton" value="no" />
                      <IonLabel className="question-style">{NO}</IonLabel>
                    </IonItem>
                  </IonRadioGroup>
                </IonCol>
              </IonRow>
            )}
            {!isManagedEquipment && optionSelectedErrorMsg && (
              <IonRow className="non-managed-equip-error">{i18n.t('RequiredField')}</IonRow>
            )}
          </IonRow>

        </IonRow>
        {pageView == PageView.LIST && (
          <React.Fragment>
            <IonRow>
              <IonCol
                size="12"
                className="start-trip-col"
              >
              </IonCol>
            </IonRow>
            {loadStops.map((stopDetails: any, index: number) => {
              return (
                <React.Fragment key={`execution-stop-details-${index}`}>
                  <IonRow>
                    <IonCol
                      size="4"
                      className={`execution-stops-sidebar-loader ${startTripModel.isStopCompleted(
                        stopDetails
                      ) && "execution-stops-sidebar-loader-completed"}`}
                    >
                      <IonImg
                        className={`execution-stop-icon ${(index == 0 &&
                          "org-stop-icon") ||
                          (index == loadStops.length - 1 && "dst-stop-icon") ||
                          "stp-stop-icon"}`}
                        src={`${(index == 0 &&
                          "assets/icon/origin-pointer.svg") ||
                          (index == loadStops.length - 1 &&
                            "assets/icon/dst-pointer.svg") ||
                          "assets/icon/stop-pointer.svg"}`}
                      />
                      <TripLoadStop
                        stopDetails={stopDetails}
                        index={index}
                        isOrigin={index == 0}
                        isDestination={index == loadStops.length - 1}
                        expandedStop={currentOpenStop}
                        shipmentId={loadDetails.shipmentId}
                        loadDetails={loadDetails}
                        {...props}
                        carrierId={props.userDetails && props.userDetails.memberDetailsResponse &&
                          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId}
                        onShowMap={(locationName: string, position: any) => {
                          onShowMap(true);
                          onSetLocationName(locationName);
                          onSetPostion(position);
                        }}
                      />
                    </IonCol>
                    <IonCol size="8">
                      <TripDetailsWeb
                        stopDetails={stopDetails}
                        index={index}
                        expandedStop={currentOpenStop}
                        shipmentId={loadDetails.shipmentId}
                        loadDetails={loadDetails}
                        userDetails={props.userDetails}
                        GPSTrackingStatus={isGPSTrackingOn}
                        optionSelected={optionSelected}
                        setoptionSelectedErrorMsg={(toggle: any) => setoptionSelectedErrorMsg(toggle)}
                        {...props}
                        previousStopDetails={index > 0 ? loadStops[index - 1] : null}
                      />
                    </IonCol>
                  </IonRow>
                </React.Fragment>
              );
            })}

            {startTripModel.isAllStopCompleted(loadDetails) &&
              !startTripModel.isTripCompleted(loadDetails) && (
                <IonRow>
                  <IonCol size="4"></IonCol>
                  <IonCol size="8" className="complete-trip-col">
                    <IonButton
                      expand="full"
                      class="complete-load-btn"
                      onClick={onCompleteTrip}
                    >

                      {COMPLETE_TRIP_CTA_TEXT}
                    </IonButton>
                  </IonCol>
                </IonRow>
              )}
          </React.Fragment>
        )}

        {pageView == PageView.MAP && (
          <React.Fragment>
            <IonRow>
              <IonCol size="12" className="execution-map-view-col">
                <LoadMap shipmentId={loadDetails.shipmentId} loadStop={loadStops} isCarrierLoad={true} />
              </IonCol>
            </IonRow>
          </React.Fragment>
        )}
      </IonGrid>
    </React.Fragment>
  );
};
